import axios from 'axios'

export const fetchSurveys = async(params = {}) => {
  try {
    return await axios.get(`surveys`, { params })
  } catch (error) {
    throw error.response
  }
}

export const fetchSurvey = async(id) => {
  try {
    return await axios.get(`/surveys/${id}`)
  } catch (error) {
    throw error.response
  }
}

export const fetchSurveysRating = async() => {
  try {
    return await axios.get(`/surveys/rating`)
  } catch (error) {
    throw error.response
  }
}
